<div *ngIf="isViewClosureData == false && viewMode == ''" class="dialog-content-max">
    <form [formGroup]="modalForm">
        <div class="resolution-container">
            <div *ngIf="isClose" class="resolution-info">
                <i class="fa fa-info-circle"></i>
                <span>
                    Closing this log indicates that the issue has been reviewed and appropriate action has been taken.
                </span>
            </div>
            <div *ngIf="onlyView" class="closure-banner">
                <i class="fa fa-check-circle"></i>
                <span>
                    This error log has been reviewed and marked as closed.
                </span>
            </div>

            <div class="grid">
                <div class="col-4 lg:col-4 md:col-4 sm:col-12">
                    <label>Organisation</label>
                    <div class="detail-value">
                        {{selectedRow?.organisation}}
                    </div>
                </div>
                <div class="col-4 lg:col-4 md:col-4 sm:col-12">
                    <label>User</label>
                    <div class="detail-value">
                        {{selectedRow?.userName}}
                    </div>
                </div>
                <div class="col-4 lg:col-4 md:col-4 sm:col-12">
                    <label>Product</label>
                    <div class="detail-value">
                        {{selectedRow?.productinitial}}
                    </div>
                </div>
            </div>

            <div class="grid">
                <div class="col-4 lg:col-4 md:col-4 sm:col-12">
                    <label>Page</label>
                    <div class="detail-value">
                        {{selectedRow?.page}}
                    </div>
                </div>
                <div class="col-4 lg:col-4 md:col-4 sm:col-12">
                    <label>Api</label>
                    <div class="detail-value">
                        {{selectedRow?.methodName}}
                    </div>
                </div>
                <div class="col-4 lg:col-4 md:col-4 sm:col-12">
                    <label>Logged On</label>
                    <div class="detail-value">
                        {{selectedRow?.createdAt}}
                    </div>
                </div>
            </div>

            <div class="grid">
                <div class="col-12 lg:col-12 md:col-12 sm:col-12">
                    <label>Log Data</label>
                    <div class="detail-value">
                        {{selectedRow?.logData}}
                    </div>
                </div>
            </div>
            <div class="section-divider"></div>
            <div *ngIf="onlyView" class="grid">
                <div class="col-4 lg:col-4 md:col-4 sm:col-12">
                    <label>Closed By</label>
                    <div class="detail-value">
                        {{selectedRow?.closedBy}}
                    </div>
                </div>
                <div class="col-4 lg:col-4 md:col-4 sm:col-12">
                    <label>Closed On</label>
                    <div class="detail-value">
                        {{selectedRow?.closedOn}}
                    </div>
                </div>
                <div class="col-4 lg:col-4 md:col-4 sm:col-12">
                    <label>Resolution Time</label>
                    <div class="detail-value">
                        {{selectedRow?.timeTaken}}
                    </div>
                </div>
            </div>

            <div *ngIf="onlyView" class="grid">
                <div class="col-12 lg:col-12 md:col-12 sm:col-12">
                    <label>Resolution Remarks</label>
                    <div class="remarks-box">
                        {{selectedRow?.remarks}}
                    </div>
                </div>
            </div>

            <div *ngIf="isClose" class="grid">
                <div class="col-4">
                    <label class="required-label">
                        Closed On <span>*</span>
                    </label>

                    <p-calendar formControlName="closedOn" [showTime]="true" hourFormat="24" dateFormat="dd-M-yy"
                        [showIcon]="true" iconDisplay="input" appendTo="body" styleClass="w-full">
                    </p-calendar>
                </div>

                <div class="col-8">
                    <label class="required-label">
                        Closure Remarks <span class="maxchars">(Max 500 chars)</span><span>*</span>
                    </label>

                    <textarea pInputTextarea rows="5" class="w-full" formControlName="closeRemarks">
                </textarea>
                </div>
            </div>

            <div *ngIf="isClose" class="identical-logs-section">
                <div class="section-divider"></div>
                <div class="grid">
                    <div class="col-12">

                        <p-table #identicalDt [value]="identicalLogs" [rows]="identicalRowsize" [scrollable]="true"
                            scrollHeight="{{commonScrollHeight}}" responsiveLayout="scroll" styleClass="p-datatable-sm"
                            [globalFilterFields]="identicalGlobalFilterFields" [sortOrder]="-1" sortField="id"
                            dataKey="id" [rowHover]="true" [resizableColumns]="true" columnResizeMode="expand"
                            [first]="identicalCurrentPageIndex" [paginator]="identicalLogs.length > 0"
                            [rowsPerPageOptions]="identicalPaginatorArray"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            [showCurrentPageReport]="true" (onPage)="handleIdenticalPageChange($event)">

                            <ng-template pTemplate="caption">
                                <div class="grid table-header justify-content-center">
                                    <div class="col-12 md:col-8 lg:col-6">
                                        <span class="p-input-icon-left w-full">
                                            <input pInputText type="text" class="form-control tablesearch w-full"
                                                placeholder="Search identical logs" (input)="
                                                identicalDt.filterGlobal($any($event.target).value,'contains');
                                                identicalSearchTerm = $any($event.target).value;" />
                                        </span>
                                    </div>
                                </div>
                            </ng-template>

                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="padding-left: 6px !important; width: 28px !important">
                                        <input type="checkbox" id="selectedProduct" [checked]="selectedId"
                                            (change)="selectAllRows($event)">
                                    </th>

                                    <ng-container *ngFor="let col of identicalSelectedColumns">
                                        <th pResizableColumn [pSortableColumn]="col.field" *ngIf="col.isChecked" [style.width]="col.width"
                    [style.minWidth]="col.width">
                    {{col.header}}<p-sortIcon [field]="col.field"></p-sortIcon>
                                         
                                    </ng-container>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-log>
                                <tr>
                                    <td style="vertical-align: top;">
                                        <input type="checkbox" [(ngModel)]="log.isSelect" 
                                            [ngModelOptions]="{standalone: true}" [id]="'log-' + log.id"
                                            (change)="selectRow(log.id, $event)">
                                    </td>
                                    <ng-container *ngFor="let col of identicalSelectedColumns">
                                        <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class"
                                            style="vertical-align: top;">
                                            <span pTooltip="{{ log[col.field] }}" class="wrap-text" [innerHTML]="
                                            highlight(log[col.field], identicalSearchTerm )">
                                            </span>
                                        </td>
                                    </ng-container>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td [attr.colspan]="identicalSelectedColumns.length" class="datanotfound">
                                        No identical open errors found
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>

            <div *ngIf="isClose" class="confirmation-section">
                <input type="checkbox" id="confirmClose" formControlName="confirmClose">

                <label for="confirmClose">
                    I confirm that this error log has been reviewed and can be marked as closed.
                </label>
            </div>
        </div>
    </form>

    <div class="custom-dialog-footer">
        <p-button class="m-1" label="Close" styleClass="customeclose"
            (click)="closemodal(modalForm,this.ref,'Are you sure you want to close?')"></p-button>

        <p-button *ngIf="isClose" class="m-1" [label]="isClosingLog ? 'Processing...' : saveTitle"
            styleClass="customesave" (click)="closeLog()"
            [disabled]="isClosingLog || modalForm.invalid || !modalForm.get('confirmClose')?.value">
        </p-button>
    </div>
</div>

<div *ngIf="isViewClosureData || viewMode != ''" class="table-container">
    <p-table #dt [value]="occurrenceData" [rows]="rowsize" [scrollable]="true" scrollHeight="{{commonScrollHeight}}"
        (sortFunction)="customSort($event)" [customSort]="true"
        [globalFilterFields]="['id','organisation','userName','productinitial','createdAt','methodName','closedBy','closedOn']"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [sortOrder]="-1"
        (onPage)="handlePageChange($event)" [rowsPerPageOptions]="paginatorArray" dataKey="id" [rowHover]="true"
        [showCurrentPageReport]="true" [resizableColumns]="true" sortField="id" columnResizeMode="expand"
        [first]="currentPageIndex" paginatorLocale="fa-IR" [paginator]="occurrenceData.length>0"
        responsiveLayout="scroll">
        <!-- search -->
        <ng-template pTemplate="caption">
            <div class="grid table-header">
                <div class="col-12 md:col-10 sm:col-12 lg:col-10">
                    <span class=" p-input-icon-lft">
                        <i icon="pi pi-search"></i>
                        <input class="form-control" pInputText type="text" id="tablesearch"
                            (input)="dt.filterGlobal($any($event.target).value , 'contains') ; searchTerm = $any($event.target).value;"
                            placeholder="Search in Application Logs" class="tablesearch"
                            pTooltip="Enter Search Criteria" tooltipPosition="top" />
                    </span>
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th style="width:60px; min-width:60px; max-width:60px; text-align:center;">
                    Action
                </th>
                <ng-container *ngFor="let col of _selectedColumns">
                    <th pResizableColumn [pSortableColumn]="col.field" *ngIf="col.isChecked">
                        {{col.header}}<p-sortIcon [field]="col.field"></p-sortIcon>
                        <!-- <p-columnFilter type="text" [field]="col.field" display="menu"></p-columnFilter> -->
                    </th>
                </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr [ngClass]="getRowClass(data)">

                <td style="width:60px; min-width:60px; max-width:60px; text-align:center;">
                    <!-- <span class="actionItm" pTooltip="View" tooltipPosition="left">
                        <i class="fa fa-eye"></i>
                    </span> -->
                    <span *ngIf="data.isClosed == 0" class="actionItm close-log-action" pTooltip="Mark as Closed"
                        tooltipPosition="left" (click)="show('Close Error Log',data)">
                        <i class="fa fa-check-circle"></i>
                    </span>
                    <span *ngIf="data.isClosed == 1" class="actionItm" pTooltip="View Closure Details"
                        tooltipPosition="left" (click)="show('Closure Data',data)">
                        <i class="fa fa-eye"></i>
                    </span>
                </td>

                <ng-container *ngFor="let col of _selectedColumns">
                    <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class"
                        style="vertical-align: top;">
                        <span pTooltip="{{data[col.field]}}" class="wrap-text"
                            [innerHTML]="highlight(data[col.field],searchTerm)">
                        </span>
                    </td>
                </ng-container>

            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="9" class="datanotfound">
                    No data available
                </td>
            </tr>
        </ng-template>
    </p-table>

    <div class="custom-dialog-footer">
        <p-button class="m-1" label="Close" styleClass="customeclose" (click)="dismiss()"></p-button>
    </div>
</div>